module.exports = __webpack_public_path__ + "img/20.61c400c8.png";